import { render } from "./rawMaterial.vue?vue&type=template&id=a18d1eec&ts=true"
import script from "./rawMaterial.vue?vue&type=script&lang=ts"
export * from "./rawMaterial.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__